<template>
  <div class="product-photos">
    <InputLabel>{{ $t('label.photo') }}</InputLabel>

    <b-row>
      <b-col cols="6" sm="3" md="6">
        <InputPhoto
          :is-loading="isLoading"
          :vuelidate="vuelidate"
          @change="$emit('change', $event)"
        />
      </b-col>
      <b-col
        v-for="(photo, photoIndex) in photos"
        :key="`photo-${photoIndex}`"
        cols="6"
        sm="4"
        md="6"
      >
        <InputPhoto
          :photo="photo.file"
          have-feature-button
          :is-featured="photo.isFeature"
          @remove="$emit('remove', photoIndex)"
          @feature="$emit('feature', photoIndex)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputLabel from '@/components/ui/input/InputLabel';
import InputPhoto from '@/components/ui/input/InputPhoto';

export default {
  props: {
    photos: Array,
    isLoading: Boolean,
    vuelidate: Object,
  },

  components: {
    InputLabel,
    InputPhoto,
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';

.product-photos {
  margin-bottom: 1rem;

  .row {
    margin: -7px;

    & > div {
      padding: 7px;
    }
  }
}
</style>
